"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Provider = require("./Provider");

var _Grip = _interopRequireDefault(require("./Grip"));

var _joinClassnames = _interopRequireDefault(require("../../utils/joinClassnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function makeClassName(className, rowIndex) {
  if (className) {
    return rowIndex % 2 > 0 ? 'group-data-row-odd' : 'group-data-row-even';
  }

  return undefined;
}

function DataRow(props) {
  var className = props.className,
      columns = props.columns,
      _props$getRowAttrs = props.getRowAttrs,
      getRowAttrs = _props$getRowAttrs === void 0 ? function () {} : _props$getRowAttrs,
      groupData = props.groupData,
      groupId = props.groupId,
      kind = props.kind,
      rowData = props.rowData,
      rowIndex = props.rowIndex,
      variant = props.variant,
      provided = props.provided;

  var _useContext = (0, _react.useContext)(_Provider.TableContext),
      columnsWidth = _useContext.columnsWidth,
      fixedColumns = _useContext.fixedColumns,
      isDragging = _useContext.isDragging,
      hasDragHandlers = _useContext.hasDragHandlers,
      contextId = _useContext.contextId,
      _useContext$dragVaria = _useContext.dragVariant,
      dragVariant = _useContext$dragVaria === void 0 ? 'row' : _useContext$dragVaria;

  var customRowAttrs = getRowAttrs(rowData, {
    isGroupHeaderRow: false
  });
  return _react.default.createElement("tr", _extends({
    ref: provided && provided.innerRef
  }, customRowAttrs, {
    className: (0, _joinClassnames.default)(makeClassName(className, rowIndex), customRowAttrs && customRowAttrs.className)
  }, provided ? provided.draggableProps : {}, provided && !hasDragHandlers && dragVariant === 'row' ? provided.dragHandleProps : {}), columns.map(function (_ref, colIndex) {
    var DataCell = _ref.DataCell,
        HeaderCell = _ref.HeaderCell,
        _ref$getCellAttrs = _ref.getCellAttrs,
        getCellAttrs = _ref$getCellAttrs === void 0 ? function () {
      return {};
    } : _ref$getCellAttrs,
        _ref$getCellKey = _ref.getCellKey,
        getCellKey = _ref$getCellKey === void 0 ? function (_rowData, columnName) {
      return columnName;
    } : _ref$getCellKey,
        name = _ref.name,
        fixed = _ref.fixed,
        rest = _objectWithoutProperties(_ref, ["DataCell", "HeaderCell", "getCellAttrs", "getCellKey", "name", "fixed"]);

    var customAttrs = getCellAttrs(rowData, name);
    var fixedColumn = fixedColumns[name];
    return _react.default.createElement("td", _extends({
      key: getCellKey(rowData, name),
      headers: groupId ? "".concat(name, " ").concat(groupId) : undefined
    }, customAttrs, {
      className: (0, _joinClassnames.default)(fixedColumn && fixedColumn.alignment, customAttrs.className),
      style: _objectSpread({}, customAttrs.style || {}, {}, isDragging ? {
        width: columnsWidth[name]
      } : {}, {}, fixedColumn ? _defineProperty({}, fixedColumn.alignment, fixedColumn.offset) : {})
    }), _react.default.createElement("div", null, _react.default.createElement(DataCell, _extends({}, rest, {
      colIndex: colIndex,
      groupData: groupData,
      kind: kind,
      name: name,
      rowData: rowData,
      rowIndex: rowIndex,
      variant: variant,
      DragHandle: provided && _react.default.createElement("div", _extends({
        "data-drag-handle-context-id": contextId
      }, provided.dragHandleProps), _react.default.createElement(_Grip.default, null))
    }))));
  }));
}

var typedMemo = _react.default.memo;

var _default = typedMemo(DataRow);

exports.default = _default;